import {makeStyles} from '@logistics-frontend/blocks'

export const useStyles = makeStyles(theme => ({
  wrapper: {
    padding: theme.spacing(0, 2),
  },
  border: {
    borderTopColor: '#d2d0cc',
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    padding: theme.spacing(2, 0),
  },
  score: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  star: {
    display: 'block',
    width: 40,
    height: 40,
    margin: `0 ${theme.spacing(1)}px`,
  },
  feedbackTitle: {
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '27px',
  },
  inputWrapper: {
    marginBottom: theme.spacing(2),
  },
}))
